export default __webpack_public_path__ + "static/TSD_Blog_Hero_Recession-0d9af15ac9fbbee95c10ffdd73e8f198.jpg";